import { useTranslation } from 'react-i18next';
import { BuyNowDigitalProduct } from 'autogen/translation-keys/trans-website-shared-buttons';
import { ButtonWithIcon, ButtonWithSpinner } from 'components/Button';
import Icon from 'components/Icon';
import type { ProductActionProps } from '../../shared/types';
import addDigitalProduct from './action';

export function AddDigitalProductButton({
    params,
    trackingInfo,
    children,
    ...restProps
}: ProductActionProps['BuyNowDigitalProduct']) {
    const { t } = useTranslation();

    return (
        <ButtonWithSpinner onClick={() => addDigitalProduct({ params, trackingInfo })} {...restProps}>
            {children || t(BuyNowDigitalProduct)}
        </ButtonWithSpinner>
    );
}

export function AddDigitalProductButtonCompact({
    params,
    trackingInfo,
    ...restProps
}: ProductActionProps['BuyMinimumNow']) {
    const { t } = useTranslation();

    return (
        <ButtonWithIcon
            icon={<Icon type="BasketPlus" size={16} fill="currentColor" />}
            onClick={() => addDigitalProduct({ params, trackingInfo })}
            type="button"
            aria-label={t(BuyNowDigitalProduct)}
            {...restProps}
        />
    );
}

export default Object.assign(AddDigitalProductButton, {
    Compact: AddDigitalProductButtonCompact
});
